// import { spacing } from '../functions';

export default {
  // paper: {
  //   padding: spacing(4),
  // },
};
